import { EMAIL_PLATFORMS } from '@this+that/constants';
import { MessagingPlatform, UserCommunication } from '@this+that/models';

export const EMAIL_PLATFORM_SET: ReadonlySet<MessagingPlatform> = new Set(
  EMAIL_PLATFORMS,
);

export const isEmailRowOfRemovedAccount =
  (
    isEmailAccountRemoved: (
      platform: MessagingPlatform,
      address: string,
    ) => boolean,
  ) =>
  (row: UserCommunication): boolean => {
    if (!row.platform || !EMAIL_PLATFORM_SET.has(row.platform)) {
      return false;
    }
    if (!row.userEmailAddress) {
      return false;
    }
    return isEmailAccountRemoved(row.platform, row.userEmailAddress);
  };
